import type { DELETE } from 'src/consts';
import type { Action } from 'src/types';

export enum Actions {
  UPDATE_LICENCE_START = 'UPDATE_LICENCE_START',
  UPDATE_LICENCE_SUCCESS = 'UPDATE_LICENCE_SUCCESS',
  UPDATE_LICENCE_FAILURE = 'UPDATE_LICENCE_FAILURE',

  UPDATE_VERIFIED_LICENCE_START = 'UPDATE_VERIFIED_LICENCE_START',
  UPDATE_VERIFIED_LICENCE_SUCCESS = 'UPDATE_VERIFIED_LICENCE_SUCCESS',
  UPDATE_VERIFIED_LICENCE_FAILURE = 'UPDATE_VERIFIED_LICENCE_FAILURE',

  REMOVE_LICENCE_START = 'REMOVE_LICENCE_START',
  REMOVE_LICENCE_SUCCESS = 'REMOVE_LICENCE_SUCCESS',
  REMOVE_LICENCE_FAILURE = 'REMOVE_LICENCE_FAILURE',
}

export type LicenceAction =
  | Action<Actions.UPDATE_LICENCE_START>
  | Action<Actions.UPDATE_LICENCE_SUCCESS>
  | (Action<Actions.UPDATE_LICENCE_FAILURE> & {
      payload: { error: Error };
    })
  | Action<Actions.UPDATE_VERIFIED_LICENCE_START>
  | Action<Actions.UPDATE_VERIFIED_LICENCE_SUCCESS>
  | (Action<Actions.UPDATE_VERIFIED_LICENCE_FAILURE> & {
      payload: { error: Error };
    })
  | (Action<Actions.REMOVE_LICENCE_START> & {
      actionName: typeof DELETE;
    })
  | Action<Actions.REMOVE_LICENCE_SUCCESS>
  | (Action<Actions.REMOVE_LICENCE_FAILURE> & {
      payload: { error: Error };
    });
